import React from "react";
import { fetchTimeInterval, getCurrentTime, isSet } from "../../../utils/commonUtils";
import FilterConditions from "./FilterConditions";
import ActivitiesService from "../../../services/ActivitiesService";
import OrganizationService from "../../../services/OrganizationService";

const singleValueOperators = [
  { label: "Equals", value: "=" },
  { label: "not Equals", value: "!=" },
];
const multiValueOperators = [
  { label: "In", value: "in" },
  { label: "not In", value: "not in" },
];
const textValueOperators = [
  { label: "Equals", value: "=" },
  { label: "not Equals", value: "!=" },
  { label: "Contains", value: "like" },
  { label: "not Contains", value: "not like" },
];
const dateAndTimeValueOperators = [
  { label: "Equals", value: "=" },
  { label: "not Equals", value: "!=" },
  { label: "Greater Than", value: ">" },
  { label: "Less Than", value: "<" },
  { label: "Greater Than or Equal To", value: ">=" },
  { label: "Less Than or Equal To", value: "<=" },
  { label: "Between", value: "between" },
];
const getValidOrgId = (orgId) => {
  const normalizedOrgId = String(isSet(orgId, "")).trim();
  if (
    normalizedOrgId === "" ||
    normalizedOrgId.toLowerCase() === "null" ||
    normalizedOrgId.toLowerCase() === "undefined"
  ) {
    return "";
  }
  return normalizedOrgId;
};

const getDefaultFilterSchema = ({ isGlobalAdminUser, selectedOrganizationUuid }) => ({
  data: [
    {
      screen_key: "VISIT",
      screen_label: "Visit",
      filters: [
        {
          field_key: "visit_date",
          label: "Visit Date",
          type: "Date",
          operators: dateAndTimeValueOperators,
          placeholder: "Visit Date",
        },
        {
          field_key: "visit_time",
          label: "Visit Time",
          type: "SelectSearchList",
          operators: dateAndTimeValueOperators,
          placeholder: "Visit Time",
          isAsync: true,
          options: [{ label: getCurrentTime(), value: getCurrentTime() }],
          loadCallBack: (val, callback) => fetchTimeInterval(val, callback),
        },
        {
          field_key: "visit_reason",
          label: "Visit Reason",
          type: "NewSelectSearchList",
          ismulti: true,
          operators: multiValueOperators,
          placeholder: "Visit Reason",
          islookup: true,
          lookup_key: "Visit Reason",
        },
        {
          field_key: "visit_category",
          label: "Visit Category",
          type: "SelectSearchList",
          ismulti: true,
          operators: multiValueOperators,
          placeholder: "Visit Category",
          islookup: true,
          lookup_key: "VisitCategory",
        },
        {
          field_key: "visit_status",
          label: "Visit Status",
          type: "SelectSearchList",
          operators: multiValueOperators,
          placeholder: "Visit Status",
          islookup: true,
          lookup_key: "visit-status",
          ismulti: true,
        },
        {
          field_key: "billing_status",
          label: "Billing Status",
          type: "SelectSearchList",
          operators: multiValueOperators,
          placeholder: "Billing Status",
          islookup: true,
          lookup_key: "billing_status",
          ismulti: true,
        },
        {
          field_key: "overall_status",
          label: "Overall Status",
          type: "SelectSearchList",
          operators: multiValueOperators,
          placeholder: "Overall Status",
          ismulti: true,
          options: [
            { label: "NOT STARTED", value: "NOT STARTED" },
            { label: "Passed", value: "Passed" },
            { label: "Pending", value: "Pending" },
            { label: "Failed", value: "Failed" },
          ],
        },
        {
          field_key: "cup_id",
          label: "Cup ID",
          type: "TextInput",
          operators: singleValueOperators,
          placeholder: "Cup ID",
        },
        {
          field_key: "record_id",
          label: "Record ID",
          type: "TextInput",
          operators: singleValueOperators,
          placeholder: "Record ID",
        },
      ],
    },
    {
      screen_key: "ACTIVITIES",
      screen_label: "Activities",
      filters: [
        {
          field_key: "actitivity_id",
          label: "Activity",
          type: "SelectSearchList",
          ismulti: true,
          operators: multiValueOperators,
          placeholder: "Activity",
          isConditional: true,
          conditional_ismulti: true,
          conditional_options: [
            { label: "Employer Services", value: "EMPLOYER_SERVICES" },
            { label: "Workcomp", value: "WORKCOMP" },
            { label: "Urgent Care", value: "URGENT_CARE" },
          ],
          conditional_callback: async ({ conditionalOptionValue }) => {
            if (isSet(conditionalOptionValue, "") === "") {
              return [];
            }
            const selectedOrgId = getValidOrgId(
              isSet(isGlobalAdminUser, false) === true
                ? selectedOrganizationUuid
                : OrganizationService.getOrgId()
            );
            if (selectedOrgId === "") {
              // return [];
            }

            const response = await ActivitiesService.getActivities(selectedOrgId, {
              type: conditionalOptionValue,
              has_pagination: false,
              checkType: true,
            });
            const rows = isSet(isSet(response, {}).data?.data, isSet(response, []));
            return isSet(rows, []).map((item) => ({
              label: isSet(item.activity_name, isSet(item.name, "")),
              value: String(isSet(item.actitivity_id, isSet(item.id, ""))),
            }));
          },

        },
        {
          field_key: "activity_code",
          label: "Activity Code",
          type: "TextInput",
          operators: singleValueOperators,
          placeholder: "Activity Code",
        },
        {
          field_key: "activity_name",
          label: "Activity Name",
          type: "TextInput",
          operators: textValueOperators,
          placeholder: "Activity Name",
        },
        {
          field_key: "activity_type",
          label: "Activity Type",
          type: "SelectSearchList",
          operators: multiValueOperators,
          placeholder: "Activity Type",
          islookup: true,
          lookup_key: "activity_type",
          ismulti: true,
        },
        {
          field_key: "type",
          label: "Screen type",
          type: "SelectSearchList",
          operators: multiValueOperators,
          placeholder: "Screen type",
          ismulti: true,
          options: [
            { label: "Employer Services", value: "EMPLOYER_SERVICES" },
            { label: "Workcomp", value: "WORKCOMP" },
            { label: "Urgent Care", value: "URGENT_CARE" },
          ],
        },
      ],
    },
    // { 
    //   screen_key: "EMPLOYEES",
    //   screen_label: "Employees",
    //   filters: [
    //     {
    //       field_key: "status",
    //       label: "Status",
    //       type: "SelectSearchList",
    //       ismulti: true,
    //       operators: multiValueOperators,
    //       placeholder: "Status",
    //       options: [
    //         { label: "Active", value: '1' },
    //         { label: "Inactive", value: '0' },
    //       ],
    //     },
    //     {
    //       field_key: "first_name",
    //       label: "First Name",
    //       type: "TextInput",
    //       operators: textValueOperators,
    //       placeholder: "First Name",
    //     },
    //     {
    //       field_key: "middle_name",
    //       label: "Middle Name",
    //       type: "TextInput",
    //       operators: textValueOperators,
    //       placeholder: "Middle Name",
    //     },
    //     {
    //       field_key: "last_name",
    //       label: "Last Name",
    //       type: "TextInput",
    //       operators: textValueOperators,
    //       placeholder: "Last Name",
    //     },
    //     {
    //       field_key: "dob",
    //       label: "DOB",
    //       type: "Date",
    //       operators: dateAndTimeValueOperators,
    //       placeholder: "DOB",
    //     },
    //     {
    //       field_key: "phone",
    //       label: "Phone",
    //       type: "Number",
    //       operators: singleValueOperators,
    //       placeholder: "Phone",
    //     },
    //     {
    //       field_key: "gender",
    //       label: "Gender",
    //       type: "SelectSearchList",
    //       operators: multiValueOperators,
    //       placeholder: "Gender",
    //       ismulti: true,
    //       options: [
    //         { label: "Female", value: "Female" },
    //         { label: "Male", value: "Male" },
    //         { label: "Unknown", value: "Unknown" },
    //       ],
    //     },
    //     {
    //       field_key:"email",
    //       label: "Email",
    //       type: "TextInput",
    //       operators: singleValueOperators,
    //       placeholder: "Email",
    //     },
    //   ],
    // },
    {
      screen_key: "ACTIVITY_CHART",
      screen_label: "Activity Chart",
      filters: [
        //  {
        //   field_key: "actitivity_id",
        //   label: "Activity",
        //   type: "SelectSearchList",
        //   ismulti: true,
        //   operators: ["=","not in","in"],
        //   placeholder: "Activity",
        //   isConditional: true,
        //   conditional_ismulti: true,
        //   conditional_options: [
        //     { label: "Employer Services", value: "EMPLOYER_SERVICES" },
        //     { label: "Workcomp", value: "WORKCOMP" },
        //     { label: "Urgent Care", value: "URGENT_CARE" },
        //   ],
        //   conditional_callback: async ({ conditionalOptionValue }) => {
        //     if (isSet(conditionalOptionValue, "") === "") {
        //       return [];
        //     }
        //     const orgId = OrganizationService.getOrgId();
        //     const response = await ActivitiesService.getActivities(orgId, {
        //       type: conditionalOptionValue,
        //       has_pagination: false,
        //     });
        //     const rows = isSet(isSet(response, {}).data?.data, isSet(response, []));
        //     return isSet(rows, []).map((item) => ({
        //       label: isSet(item.activity_name, isSet(item.name, "")),
        //       value: String(isSet(item.actitivity_id, isSet(item.id, ""))),
        //     }));
        //   },
        // },
        {
          field_key : "status",
          label: "Result Status",
          type: "SelectSearchList",
          operators: multiValueOperators,
          placeholder: "Result Status",
          ismulti: true,
          options: [
            { label: "Not Started", value: "Not Started" },
            { label: "Pending", value: "Pending" },
            { label: "Normal", value: "Normal" },
            { label: "Abnormal", value: "Abnormal" },
            { label: "Negative", value: "Negative" },
            { label: "Positive", value: "Positive" },
            { label: "Dispensed", value: "Dispensed" },
            { label: "Administered", value: "Administered" },
            { label: "Failed", value: "Failed" },
            { label: "Passed", value: "Passed" },
            { label: "Non-Negative", value: "Non-Negative" },
            { label: "Cancelled", value: "Cancelled" },
            { label: "Inconclusive", value: "Inconclusive" },
          ],
        },
        {
          field_key: "activity_status",
          label: "Activity Status",
          type: "SelectSearchList",
          operators: multiValueOperators,
          placeholder: "Activity Status",
          ismulti: true,
          options: [
            { label: "Not Started", value: "Not Started" },
            { label: "Pending", value: "Pending" },
            { label: "Pending Lab Confirmation", value: "Pending Lab Confirmation" },
            { label: "Pending MRO Confirmation", value: "Pending MRO Confirmation" },
            { label: "Ready for Review", value: "Ready for Review" },
            { label: "Completed", value: "Completed" },
            { label: "Cancelled", value: "Cancelled" },
          ],
        },
        {
          label: "Reason",
          field_key: "reason",
          type: "SelectSearchList",
          ismulti: true,
          operators: multiValueOperators,
          placeholder: "Reason",
          options: [
            { label: "Pre-employment", value: "Pre-employment" },
            { label: "Followup", value: "Followup" },
            { label: "Random", value: "Random" },
            { label: "Post Accident", value: "Post Accident" },
            { label: "Return to Duty", value: "Return to Duty" },
            { label: "Reasonable Suspicion/Cause", value: "Reasonable Suspicion/Cause" },
            { label: "Periodic Medical", value: "Periodic Medical" },
            { label: "Promotion", value: "Promotion" },
            { label: "Transfer", value: "Transfer" },
            { label: "Diversion", value: "Diversion" },
            { label: "Fishing License", value: "Fishing License" },
            { label: "Other", value: "Other" },
          ],
        }
      ],
    },
    {
      screen_key: "INCIDENTS",
      screen_label: "Incidents",
      filters: [
        {
          field_key: "date_of_incident",
          label: "Date of Incident",
          type: "Date",
          operators: dateAndTimeValueOperators,
          placeholder: "Date of Incident",
        },
        {
          field_key: "time_of_incident",
          label: "Time of Incident",
          type: "SelectSearchList",
          operators: dateAndTimeValueOperators,
          isAsync: true,
          options: [{ label: getCurrentTime(), value: getCurrentTime() }],
          loadCallBack: (val, callback) => fetchTimeInterval(val, callback),
          placeholder: "Time of Incident",
        },
        {
          field_key: "nature_of_incident",
          label: "Nature of Incident",
          type: "SelectSearchList",
          operators: multiValueOperators,
          ismulti: true,
          placeholder: "Nature of Incident",
          islookup: true,
          lookup_key: "nature_of_incident",
        },
        {
          field_key: "body_zone",
          label: "Body Zone",
          type: "SelectSearchList",
          ismulti: true,
          operators: multiValueOperators,
          placeholder: "Body Zone",
          islookup: true,
          lookup_key: "body_zone",
        },
        {
          field_key: "relatedness",
          label: "Relatedness",
          type: "SelectSearchList",
          ismulti: true,
          operators: multiValueOperators,
          placeholder: "Relatedness",
          options: [
            { label: "Work Related", value: "Work Related" },
            { label: "First Aid", value: "First Aid" },
            { label: "Undetermined", value: "Undetermined" },
          ],
        },
        {
          field_key: "incident_type",
          label: "Incident Type",
          type: "SelectSearchList",
          operators: multiValueOperators,
          placeholder: "Incident Type",
          ismulti: true,
          options: [
            { label: "Injury", value: "Injury" },
            { label: "Exposure", value: "Exposure" },
            { label: "Illness", value: "Illness" },
          ],
        },
      ],
    }
  ],
});

export function resolveRoleFilterSchema(filterConfigData, { isGlobalAdminUser, selectedOrganizationUuid }) {
  const defaultFilterSchema = getDefaultFilterSchema({
    isGlobalAdminUser,
    selectedOrganizationUuid,
  });
  return isSet(filterConfigData, defaultFilterSchema);
}

const DataFilters = ({
  filterConfigData,
  validationMsg,
  dataFilterValidationErrors,
  value,
  onChange,
  isGlobalAdminUser,
  selectedOrganizationUuid,
  setValidationMessage,
}) => {
  const filterSchema = resolveRoleFilterSchema(filterConfigData, {
    isGlobalAdminUser,
    selectedOrganizationUuid,
  });

  return (
    <div className="px-3 sh_datafilter_config" id='accordion1'>
          <FilterConditions
            data={isSet(filterSchema.data, [])}
            value={value}
            onChange={onChange}
            validationErrors={isSet(dataFilterValidationErrors, {})}
            setValidationMessage={setValidationMessage}
          />
    </div>
  );
};

DataFilters.defaultProps = {
  filterConfigData: null,
  validationMsg: "",
  dataFilterValidationErrors: {},
  value: {},
  onChange: () => {},
  isGlobalAdminUser: false,
  selectedOrganizationUuid: "",
  setValidationMessage: () => {},
};

export default DataFilters;
